import { useConditional } from "../state/storeConditional "


const useGetMetaRamadan = () => {
    const {updateIsRamadan} = useConditional()

  const getMetaRamadan = (meta) => {
    
      if(meta[ 'meta-key' ] === 'ramadan' && meta?.value && typeof meta?.value === 'string'){
        const converter = JSON.parse( meta?.value)

        updateIsRamadan(converter)
      }
  }

  return {getMetaRamadan}
}

export default useGetMetaRamadan